/* @flow */

export {LinkedEntity} from './linked-entity';
export {LinkedLeadEntity} from './linked-lead-entity';
